/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_P1_TitleInputs */

const es_cap_p1_title = /** @type {(inputs: Cap_P1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más clientes, sin buscarlos`)
};

const gl_cap_p1_title = /** @type {(inputs: Cap_P1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máis clientes, sen buscalos`)
};

const en_cap_p1_title = /** @type {(inputs: Cap_P1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More clients, without chasing them`)
};

/**
* | output |
* | --- |
* | "More clients, without chasing them" |
*
* @param {Cap_P1_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_p1_title = /** @type {((inputs?: Cap_P1_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_P1_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_p1_title(inputs)
	if (locale === "en") return en_cap_p1_title(inputs)
	return es_cap_p1_title(inputs)
});